/* ═══════════════════════════════════════════════════════════════════════════
   Channels — contact-channel pill styles (WhatsApp / Viber / Email).
   Non-component module kept separate from icons.jsx so that file only exports
   components (React Fast Refresh requirement). Extracted from App.jsx
   (2026-05-29); see docs/superpowers/specs/2026-05-29-app-jsx-decomposition-design.md
   ═══════════════════════════════════════════════════════════════════════════ */
import { IcWA, IcViber, IcMail } from './icons.jsx';

// Channel pill styles tuned for Tavelo's typographic vocabulary: muted, on-brand colors
// instead of saturated brand-green / brand-purple. The icon shape carries recognition.
const CHANNEL_STYLES = {
  whatsapp: { bg: '#5A7247', fg: '#fff',    border: '#5A7247', Icon: IcWA,    label: 'WhatsApp' },
  viber:    { bg: '#6E5A9A', fg: '#fff',    border: '#6E5A9A', Icon: IcViber, label: 'Viber' },
  email:    { bg: '#FFFDF8', fg: '#3D2B1F', border: '#E8D5B0', Icon: IcMail,  label: 'Email' },
};

function channelButtonStyle(channel) {
  const s = CHANNEL_STYLES[channel];
  return {
    flex: 1, padding: '8px 10px',
    background: s.bg, color: s.fg, border: '1px solid ' + s.border,
    borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  };
}

export { CHANNEL_STYLES, channelButtonStyle };
